module.exports = __webpack_public_path__ + "img/defect.eb571602.png";